const formatCurrency = (currency: number): string =>
  currency.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })

export default formatCurrency
